export const CodeBookFragment = gql`
  fragment CodeBookFragment on CodeBook {
    id
    importError
    importStartedAt
    importStatus
    name
    items {
      ...CodeBookItemFragment
    }
  }
`

export const CodeBookListCardFragment = gql`
  fragment CodeBookListCardFragment on CodeBook {
    id
    importError
    importStartedAt
    importStatus
    itemCount
    name
  }
`
